import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Spin, message } from 'antd';
import { debounce } from 'lodash';

import {
  getGoodsList,
  addToCart,
  reduceFromCart,
  changeCartNum,
  deleteOneCartGoods,
  deleteAllCartGoods,
  getClientList,
  updateBuyWay,
  initState,
  updateSearchParams,
  getStorageSetting,
} from '@/redux/actions/goods';
// import throttle from '@/utils/throttle';
import { renderIntlLabel } from '@/utils';

import GoodsList from './GoodsList';
import GoodsCart from './GoodsCart';
import GoodSearch from './GoodSearch';

import { stepEnumKey } from '../help';
import { IChangeNumber } from '../type';

import styles from './index.module.scss';

interface IChooseGoods {
  step: stepEnumKey;
  saleGoodsLoading: boolean;
  saleGoodsList: Object[];
  saleGoodsListCopy: Object[];
  cartList: Object;
  searchParam: any;
  storageType: 1 | 2;
  initState: () => void;
  getGoodsList: (data: any) => void;
  deleteOneCartGoods: () => void;
  deleteAllCartGoods: () => void;
  addToCart: (goodsItem: Object, index: number) => void;
  reduceFromCart: (goodsItem: Object, index: number) => void;
  changeCartNum: (goodsItem: Object, index: number, number: number) => void;
  updateSearchParams: (field: any, value: any) => void;
  getStorageSetting: () => void;
}

const Index = ($$: IChooseGoods) => {
  // if ($$.step !== stepEnumKey.first) return null;

  const { saleGoodsList = [], saleGoodsListCopy = [], cartList = {}, storageType } = $$;

  useEffect(() => {
    $$.initState();
    $$.getGoodsList($$.searchParam);
    $$.getStorageSetting();

    return () => {
      $$.initState();
    };
  }, []);

  // 购物车数量 change
  const changeCartNumber = ({ type, goodsItem, number, index }: IChangeNumber) => {
    switch (type) {
      case 'add':
        // 判断前台库存是否足够 storageType
        const { qty, storageQty } = goodsItem || {};
        const frontNotEnough = storageType === 2 && (!qty || qty === 0);
        const storageNotEnough = storageType === 1 && (!storageQty || storageQty === 0);
        if (frontNotEnough || storageNotEnough) {
          message.error(renderIntlLabel('goods_msg_add_unsuccessfully_for_understock'));
          return;
        }
        $$.addToCart(goodsItem, index);
        break;
      case 'reduce':
        $$.reduceFromCart(goodsItem, index);
        break;
      case 'change':
        $$.changeCartNum(goodsItem, index, number);
        break;
      default:
        break;
    }
  };

  // 商品tab筛选
  const onRadioChange = (e: any) => {
    $$.updateSearchParams('type', e.target.value);
    $$.updateSearchParams('goodsName', '');
    $$.getGoodsList({ type: e.target.value });
  };

  // 商品搜索关键词输入
  const handleInputChange = debounce((e: any) => {
    $$.updateSearchParams('goodsName', e.target.value);
    $$.updateSearchParams('type', '');
    $$.getGoodsList({ goodsName: e.target.value?.trim() });
  }, 500);

  return (
    <Spin spinning={$$.saleGoodsLoading}>
      <div
        className={styles.container}
        style={{ display: $$.step !== stepEnumKey.first ? 'none' : 'flex' }}
      >
        <section className={styles.goodsContent}>
          <GoodSearch
            status={$$.searchParam?.type}
            // keywords={$$.searchParam?.goodsName}
            onRadioChange={onRadioChange}
            handleInputChange={handleInputChange}
          />
          <GoodsList
            list={saleGoodsList}
            intialList={saleGoodsListCopy}
            cartList={cartList}
            onChangeNumber={changeCartNumber}
            storageType={storageType}
          />
        </section>
        {/* 右侧购物车与结算 */}
        <section>
          <GoodsCart
            list={cartList}
            goodsList={saleGoodsListCopy}
            onChangeNumber={changeCartNumber}
            deleteOneCartGoods={$$.deleteOneCartGoods}
            deleteAllCartGoods={$$.deleteAllCartGoods}
          />
        </section>
      </div>
    </Spin>
  );
};

const mapStateToProps = (state: any) => {
  return {
    ...state.goods,
  };
};

export default connect(mapStateToProps, {
  getGoodsList,
  addToCart,
  reduceFromCart,
  changeCartNum,
  deleteOneCartGoods,
  deleteAllCartGoods,
  getClientList,
  updateBuyWay,
  initState,
  updateSearchParams,
  getStorageSetting,
})(React.memo(Index));
